import { HistoryTable } from '../components/HistoryTable';
import { listHistoryJobs } from '../api';
import { usePolling } from '../hooks/usePolling';

export function VideoHistoryPage() {
  const { data: jobs, loading, error, refresh } = usePolling(listHistoryJobs, 5000);

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-primary-900">Video History</h1>
          <p className="text-sm text-primary-500 mt-1">
            Completed and failed turntable-video scans. Use the row actions to view the video, re-run with the
            current settings, see the config that was used, or delete the entry.
          </p>
        </div>
        {jobs && (
          <div className="text-sm text-primary-500">
            <span className="font-semibold text-primary-900">{jobs.length}</span> total
          </div>
        )}
      </div>

      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          Failed to load: {error}
        </div>
      )}

      {loading && !jobs ? (
        <div className="text-sm text-primary-400">Loading…</div>
      ) : (
        <HistoryTable jobs={jobs ?? []} onMutated={refresh} />
      )}
    </div>
  );
}
